import Route from '@ember/routing/route';

export default class EnIndexRoute extends Route {
  // This route inherits locale setup from parent 'en' route
  // No additional setup needed - parent route handles locale and SEO
}



